<template>
  <div class="input" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div :class="controlClasses">
      <BaseCurrency
        :id="id"
        v-model.number="text"
        :type="type"
        :error="error"
        :disabled="disabled"
        :precision="precision"
        :value-as-integer="valueAsInteger"
        @input="$emit('input', text)"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseCurrency from "@/components/Base/Controls/BaseCurrency";

export default {
  name: "CurrencyControl",
  components: {
    BaseCurrency
  },
  extends: BaseFormControl,
  props: {
    value: {
      type: [Number, String, null],
      required: true
    },
    countChars: {
      type: Boolean,
      default: false
    },
    maxChars: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "text"
    },
    allowAllCaps: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    currency: {
      type: String,
      default: "PLN"
    },
    locale: {
      type: String,
      default: "pl-PL"
    },
    precision: {
      type: Number,
      default: 2
    },
    valueAsInteger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: this.value
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue === null) {
        newValue = 0;
      }
      if (newValue != oldValue) {
        this.text = newValue;
      }
    }
  }
};
</script>
